import { Matrix4, Mesh, RepeatWrapping, TextureLoader, Vector3 } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../../assets/models/Handheld_v5.glb";
import { GUI } from "dat.gui";
import ObserverEmitter, { EVENTS } from "../../../../../emitter/Observer";
import { handHeldsScreensTopicFive } from "../../../../../assets/activityes/topicFiveActivity";
const angulo = (Math.PI / 180) * 7;
export class HandHeld extends Mesh {
	constructor(camera, loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);

		let dracoloader = new DRACOLoader();
		this.camera = camera;
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.position.set(0.2, -0.4017, 4.5803);
		// const posi = this.camera.position.clone();
		// this.position.set(this.camera.position.clone());
		// this.translateZ(-1);
		this.rotation.set(1.0332, 0, 0.18);
		this.scale.set(2, 2, 2);

		// this.rotation.y = MathUtils.degToRad(90)
		// this.helpers();
		this.observerListtneners();
	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);
			this.Gondola_3 = gltf.scene.getObjectByName("Handheld-pantalla", true);
			this.updateMaterialScreen(handHeldsScreensTopicFive.screen1S5A1);
			// this.Gondola_3.material.map.repeat.set(1, 1);
			// this.Gondola_3.material.map.rotation = Math.PI / ;
		});
	}

	updateMaterialScreen(img) {
		const imgLoader = new TextureLoader();
		const textura = imgLoader.load(img);
		this.Gondola_3.material.map = textura;
		this.Gondola_3.material.lightMap = textura;
		this.Gondola_3.material.lightMapIntensity = 1;
		this.Gondola_3.material.map.wrapS = RepeatWrapping;
		this.Gondola_3.material.map.wrapT = RepeatWrapping;
		this.Gondola_3.material.map.repeat.y = -1;
	}

	observerListtneners() {
		ObserverEmitter.on(EVENTS.subtopicFive.activityOne.clicktoscreen1, () => {
			// this.updateMaterialScreen(handHeldsScreensTopicFor.handheld_s4a1_screen2);
		});
		ObserverEmitter.on(EVENTS.subtopicFive.activityOne.hiddenHandler, () => {
			this.visible = false;
		});
	}

	helpers() {
		const gui = new GUI();
		const premiaFolder = gui.addFolder("handheld");
		premiaFolder.add(this.position, "x", -10, 10).step(0.0001).name("Posición X");
		premiaFolder.add(this.position, "y", -10, 10).step(0.0001).name("Posición Y");
		premiaFolder.add(this.position, "z", -10, 10).step(0.0001).name("Posición Z");
		premiaFolder.add(this.rotation, "x", -5, 5).step(0.0001).name("rotation X");
		premiaFolder.add(this.rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		premiaFolder.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		premiaFolder.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		// premiaFolder.open();
	}

	renderAnimations() {
		const direccionMira = new Vector3();
		this.camera.getWorldDirection(direccionMira);
		const matrizRotacion = new Matrix4().makeRotationAxis(new Vector3(1, 3, 0), -angulo);
		direccionMira.applyMatrix4(matrizRotacion);

		const vectorDesplazamiento = direccionMira.multiplyScalar(0.7);
		this.position.copy(this.camera.position).add(vectorDesplazamiento);
		this.lookAt(this.camera.position);
	}
}
